const promotion = {
  promotion: {
    pageTitle: 'Promotion',
    pageDescription: '고객을 위한 합리적인 프로모션을 제공합니다',

    card: {
      title: 'Join IOPS SPACE!',
      description: '런칭 기념으로, 2025년 한 달간 IOPS의 지상국 스케줄링 서비스를 무료로 이용할 수 있습니다.',
      noticeTitle: '유의사항',
      noticeDetail: 'IOPS 지상국 접속 스케줄링은 하루 1회(Pass)만 예약 가능하며 이용 가능 시간은 한국 시간(KST) 기준 오후 2시부터 5시까지입니다. (UTC 기준 오전 5시 ~ 8시)',
      button: '회원가입'
    }
  }
};



export default promotion;